
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/my-store-credit",
      function () {
        return require("private-next-pages/account/my-store-credit/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/my-store-credit"])
      });
    }
  